import React from "react";
import { Button, Spinner } from "reactstrap";

import {
  age,
  checkGroups,
  getCamelCaseWord,
  populateArray,
} from "../../../../static/brands_wholesalers_data";
import NAIMAGE from "../../../../static/NA.png";
const ProfileDetailsMultiGenderItem = ({
  data,
  title,
  brandTargetGroup,
  onClick,
  main,
  isAggregated,
}) => {
  const group = checkGroups(brandTargetGroup);
  const image =
    group === "All"
      ? main?.find((a) => a?.label === "All ages")?.imageWhite
      : group === "Men"
      ? main[0]?.imageWhite
      : group === "Women"
      ? main[0]?.imageWomenWhite
      : group === "Men/Women"
      ? main[0]?.imageBothWhite
      : main[0]?.imageWhite
      ? data?.find((a) => a?.label === "All ages")?.imageWhite
      : group === "Men"
      ? data[0]?.imageWhite
      : group === "Women"
      ? data[0]?.imageWomenWhite
      : group === "Men/Women"
      ? data[0]?.imageBothWhite
      : data[0]?.imageWhite;

  return (
    <div className="flex-grow-1 mb-3">
      <h6 className="font-weight-bold text-truncate">{title}</h6>
      <hr className="my-2" />
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && onClick()}
        className="d-flex flex-column justify-content-center align-items-center position-relative"
        style={{
          minWidth: "230px",
          width: "100%",
          height: "220px",
          borderRadius: "12px",
          backgroundColor: main?.length > 0 ? "#E3C2A8" : "#000",
          gap: "21px",
          cursor: "pointer",
        }}
      >
        {isAggregated && (
          <div
            style={{
              top: "10px",
              left: "10px",
              position: "absolute",
              padding: "3px 10px",
              borderRadius: "12px",
              fontSize: "11px",
              fontWeight: "bold",
              color: "#fff",
              backgroundColor: "#e8b009",
              boxShadow: "0 1px 4px rgba(0,0,0,0.35)",
              zIndex: 1,
            }}
          >
            Aggregated
          </div>
        )}
        {data?.length > 0 ? (
          <>
            <img
              src={
                image || main[0]?.imageWhite || data[0]?.imageWhite || NAIMAGE
              }
              alt="Group"
              width="90px"
              style={{ maxHeight: "150px", height: "auto" }}
            />
            <span
              style={{
                color: main?.length > 0 ? "#000" : "#fff",

                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              {getCamelCaseWord(main[0]?.label || data[0]?.label)}
            </span>

            {data?.length > 1 && (
              <div
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "0",
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#E2AD82",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                  }}
                >
                  +{data?.length - 1}
                </span>
              </div>
            )}
          </>
        ) : data[0] === "no data" ? (
          <span style={{ color: "white" }}>no data</span>
        ) : (
          <div className="d-flex align-items-center gap-2">
            <Spinner color="light" size="sm" />
            <span style={{ color: "#fff" }}>Fetching</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileDetailsMultiGenderItem;
